import { IBudget } from "../../../../models/budgetV2";
import { Occurrence } from "../../../../models/occurrence";
import {
  IOccurrenceCustomerData,
  IOccurrenceVehicleData,
} from "../../../../api/fetchOccurence";
import { BudgetRecipient } from "../../enums/budgetRecipient";

export const resolveOccurrenceUserRole = (
  profile: BudgetRecipient | string
): "TOWER" | "CONSULTANT" | "MANAGER" | "PARTNERSHIP" => {
  if (profile === BudgetRecipient.TOWER || profile === "FACTORY" || profile === "TOWER") {
    return "TOWER";
  }
  if (profile === BudgetRecipient.MANAGER || profile === "MANAGER") {
    return "MANAGER";
  }
  return "CONSULTANT";
};

export const applyOccurrenceDataToBudget = (
  prevBudget: IBudget,
  occurrenceResult: Occurrence | undefined,
  vehicleData?: IOccurrenceVehicleData,
  customerData?: IOccurrenceCustomerData
): IBudget => ({
  ...prevBudget,
  occurrenceProtocolNumber:
    vehicleData?.protocolNumber ?? occurrenceResult?.protocolNumber ?? prevBudget.occurrenceProtocolNumber,
  vehicleChassis: vehicleData?.chassis ?? occurrenceResult?.vehicleChassis,
  vehicleLicensePlate: vehicleData?.licensePlate ?? occurrenceResult?.vehicleLicensePlate,
  vehicleModel: vehicleData?.model ?? vehicleData?.vehicleName ?? occurrenceResult?.vehicleModel,
  vehicleOdometer: vehicleData?.odometer ?? occurrenceResult?.vehicleOdometer,
  vehicleHourMeter:
    Number(vehicleData?.hourMeter ?? vehicleData?.hourmeter ?? occurrenceResult?.vehicleHourmeter) || undefined,
  vehicleContractNumber: vehicleData?.contractNumber ?? occurrenceResult?.contractNumber ?? undefined,
  customerName: customerData?.name ?? occurrenceResult?.customer,
  customerEmail: customerData?.email,
  customerPhone: customerData?.phone,
});
